import Phaser from 'phaser'
import ContextMenu from '/ui/contextMenu'
import ContextButton from '/ui/contextButton'
import LevelGenerator from '/components/levelGenerator'

export default class LevelEditor extends Phaser.GameObjects.Container {
  /**
   * @param {Phaser.Scene} scene
   */
  constructor (scene) {
    super(scene)

    this.scene = scene
    this.scene.input.mouse.disableContextMenu()

    this.addMenu = new ContextMenu(this.scene)
    // this.addMenu = new ContextMenu(this.scene.scene.manager.getScene('EditorHudScene'))
    // this.addMenu.addButton('Moving Platform', () => { this.addMover() })
    this.addMenu.addButton('GENERATE', () => { this.generateLevel() })
    this.addMenu.addButton('Obstacle', () => { this.addObstacle() })
    this.addMenu.addButton('Platform', () => { this.addStatic() })
    this.addMenu.addButton('Moving Pltfm', () => { this.addMover() })
    this.addMenu.addButton('Breakable Pltfm', () => { this.addBreakable() })
    this.addMenu.addButton('Repeating Pltfm', () => { this.addRepeating() })
    this.addMenu.addButton('Repeating Obs', () => { this.addObstacleGun() })
    this.addMenu.addButton('Cake', () => { this.addCake() })
    this.addMenu.addButton('Guide Point', () => { this.addGuidePoint() })
    this.addMenu.addButton('Guide Start', () => { this.addGuideStart() })
    this.addMenu.hide()

    this.objectMenu = new ContextMenu(this.scene)
    this.objectMenu.hide()

    this.scene.scene.run('EditorHudScene')
    this.topLeftMenu = new ContextMenu(this.scene.scene.manager.getScene('EditorHudScene'))
    this.topLeftMenu.addButton('File', () => { this.fileMenu.toggle(0, 50) })
    this.topLeftMenu.show(0, 0)
    this.topLeftMenu.dontHideOnClick = true
    this.fileMenu = new ContextMenu(this.scene.scene.manager.getScene('EditorHudScene'))
    this.fileMenu.addButton('New Level..', () => { this.loadEmptyLevel() })
    this.fileMenu.addButton('Load Level..', () => { this.load() })
    this.fileMenu.addButton('Save Level..', () => { this.save(true) })
    this.fileMenu.hide()
    this.scene.scene.sleep('EditorHudScene')

    this.boxIm = this.scene.matter.add.image(0, 0, 'white')
    this.boxIm.setScale(100, 100)
    this.boxIm.setAlpha(0.5)
    this.boxIm.setDepth(2000)
    this.boxIm.setIgnoreGravity(true)
    this.boxIm.setSensor(true)
    this.boxIm.setInteractive({
      draggable: true
    })
    this.boxIm.on('drag', (pointer, dragX, dragY) => {
      var p = this.scene.cameras.main.getWorldPoint(pointer.x, pointer.y)
      this.boxDrag(Math.ceil(p.x / 10) * 10, Math.ceil(p.y / 10) * 10)
    })

    this.image = this.scene.matter.add.image(0, 0, 'white')
    this.image.setScale(100, 100)
    this.image.setAlpha(0.01)
    // this.image.refreshBody()
    this.image.setDepth(-1)
    this.image.setIgnoreGravity(true)
    this.image.setSensor(true)
    this.image.setInteractive({ draggable: true })
      .on('pointerdown', (pointer, localX, localY, event) => {
        if (this.scene.input.activePointer.leftButtonDown()) {
          // console.log('LMB')
          // if (this.waitingForAttach) {
          //   console.log('attach ')
          // }

          if (this.isBoxDragging) {
            this.cancelBox()
          }
          this.addMenu.hide()
          this.objectMenu.hide()
          this.fileMenu.hide()
        } else if (this.scene.input.activePointer.rightButtonDown()) {
          if (this.enabled) {
            this.showContextMenu(this.scene.input.activePointer.x, this.scene.input.activePointer.y)
          }
        }
      })

    // this.scene.input.on('pointerdown', (pointer) => {
    //   if (this.scene.input.activePointer.leftButtonDown()) {
    //     this.addMenu.hide()
    //     this.objectMenu.hide()
    //     this.fileMenu.hide()

    //   } else if (this.scene.input.activePointer.rightButtonDown()) {
    //     this.showContextMenu(pointer.x, pointer.y)
    //   }
    // })

    this.disable()
    this.cancelBox()
  }

  setupInput () {
    this.keyEditor = this.scene.input.keyboard.addKey('Q')
    this.keyDelete = this.scene.input.keyboard.addKey('delete')
    this.keyShift = this.scene.input.keyboard.addKey('shift')

    this.keyEditorWasDown = false
    this.keyShiftWasDown = false
  }

  enable () {
    if (!(location.hostname === 'localhost' && process.env.NODE_ENV === 'development')) {
      return
    }

    if (!this.enabled) {
      this.scene.isCustomLevel = true
      for (var i = 0; i < this.scene.spawner.objects.length; i++) {
        this.scene.spawner.objects[i].showEditing()
      }
      // for (var h = 0; h < this.scene.spawner.objects[i].handles.length; h++) {
      //   this.scene.spawner.objects[i].handles[h].showHandlers()
      // }
      // }

      this.scene.scene.wake('EditorHudScene')
    }
    this.enabled = true
    this.scene.scene.manager.getScene('TouchScene').disable()
    // if (touch) { touch.disable() }
  }

  disable () {
    this.addMenu.hide()
    this.objectMenu.hide()
    for (var i = 0; i < this.scene.spawner.objects.length; i++) {
      this.scene.spawner.objects[i].hideEditing()
    }
    this.scene.scene.sleep('EditorHudScene')
    this.enabled = false

    this.scene.scene.manager.getScene('TouchScene').enable()
    // if (touch) { touch.enable() }
  }

  preUpdate (time, delta) {
    if (this.keyEditorWasDown && !this.keyEditor.isDown) {
      if (this.enabled) {
        this.disable()
      } else {
        this.enable()
      }
    }
    this.keyEditorWasDown = this.keyEditor.isDown

    this.pointer = this.scene.cameras.main.getWorldPoint(this.scene.input.activePointer.x, this.scene.input.activePointer.y)
    this.image.x = this.pointer.x
    this.image.y = this.pointer.y

    if (this.keyShift.isDown) {
      if (!this.keyShiftWasDown) {
        this.boxStartX = this.pointer.x
        this.boxStartY = this.pointer.y
        this.isBoxDragging = false
      }

      this.boxIm.x = 0.5 * this.pointer.x + (0.5 * this.boxStartX)
      this.boxIm.y = 0.5 * this.pointer.y + (0.5 * this.boxStartY)
      var sX = Math.max(1, Math.abs(this.pointer.x - this.boxStartX))
      var sY = Math.max(1, Math.abs(this.pointer.y - this.boxStartY))
      this.boxIm.setScale(sX, sY)
    } else if (this.keyShiftWasDown) {
      this.checkBoxSelect()
    }
    this.keyShiftWasDown = this.keyShift.isDown

    if (this.waitingForAttach) {
      this.currentEditable.drawParentLine(this.image.x, this.image.y)
    }
  }

  cancelBox () {
    this.boxSelected = []
    this.isBoxDragging = false
    this.boxIm.x = 0
    this.boxIm.y = 0
    this.boxIm.setScale(1, 1)
  }

  checkBoxSelect () {
    this.boxSelected = []
    var obj
    for (var i = 0; i < this.scene.spawner.objects.length; i++) {
      obj = this.scene.spawner.objects[i].image
      if (obj.x > this.boxIm.x - (this.boxIm.scaleX / 2) && obj.x < this.boxIm.x + (this.boxIm.scaleX / 2) &&
      obj.y > this.boxIm.y - this.boxIm.scaleY / 2 && obj.y < this.boxIm.y + this.boxIm.scaleY / 2) {
        this.boxSelected.push(obj.parentContainer)
      }
    }
  }

  boxDrag (x, y) {
    if (!this.isBoxDragging) {
      this.boxDragOriginX = x
      this.boxDragOriginY = y
    }

    this.isBoxDragging = true

    var offsetX = x - this.boxDragOriginX
    var offsetY = y - this.boxDragOriginY
    for (var i = 0; i < this.boxSelected.length; i++) {
      this.boxSelected[i].positionEditor.setPos(this.boxSelected[i].positionEditor.editable.image.x + offsetX, this.boxSelected[i].positionEditor.editable.image.y + offsetY)
    }
    this.boxIm.x += offsetX
    this.boxIm.y += offsetY

    this.boxDragOriginX = x
    this.boxDragOriginY = y
  }

  showContextMenu (x, y) {
    var world = this.scene.cameras.main.getWorldPoint(x, y)
    this.addMenu.show(world.x, world.y)
  }

  showDeleteMenu (x, y, deleteCallback) {
    var world = this.scene.cameras.main.getWorldPoint(x, y)
    this.objectMenu.clear()
    this.objectMenu.addButton('Delete', () => { deleteCallback() })
    this.objectMenu.show(world.x, world.y)
  }

  showObjectMenu (x, y, editable) {
    this.currentEditable = editable
    var world = this.scene.cameras.main.getWorldPoint(x, y)

    this.objectMenu.clear()

    this.objectMenu.addButton('Delete', () => {
      this.deleteObject(this.currentEditable)
    })

    this.objectMenu.addButton('Duplicate', () => {
      this.duplicateObject(this.currentEditable)
    })

    if (this.currentEditable.parent) {
      this.objectMenu.addButton('Detach', () => {
        this.currentEditable.detachFromParent()
      })
    } else {
      this.objectMenu.addButton('AttachTo', () => {
        this.waitingForAttach = true
      })
    }

    var editables = this.currentEditable.editableVars
    for (var i = 0; i < editables.length; i++) {
      this.objectMenu.addEditable(i, editables[i].key, editables[i].getter(), (index, value) => { this.currentEditable.setValue(editables[index].key, value) })
    }

    this.objectMenu.show(world.x, world.y)
  }

  addMover () {
    var def = {
      type: 'sPl',
      data: {
        x: this.pointer.x,
        y: this.pointer.y,
        width: 400,
        height: 100,
        isMoving: true,
        p0: { x: this.pointer.x, y: this.pointer.y },
        p1: { x: this.pointer.x + 500, y: this.pointer.y }
      }
    }
    this.scene.spawner.spawnFromDef(def, true)
  }

  generateLevel () {
    var gen = new LevelGenerator(this.scene)
    gen.newGenerateLevel('777', this.scene.difficultyManager.rating)
  }

  addObstacle () {
    var def = { type: 'obs', data: { x: this.pointer.x, y: this.pointer.y, width: 100, height: 100 } }
    this.scene.spawner.spawnFromDef(def, true)
  }

  addStatic () {
    var def = { type: 'sPl', data: { x: this.pointer.x, y: this.pointer.y, width: 300, height: 300 } }
    this.scene.spawner.spawnFromDef(def, true)
  }

  addDeathZone () {
    var def = { type: 'dZone', data: { x: this.pointer.x, y: this.pointer.y, width: 200, height: 200 } }
    this.scene.spawner.spawnFromDef(def, true)
  }

  addCake () {
    var def = { type: 'cake', data: { x: this.pointer.x, y: this.pointer.y } }
    this.scene.spawner.spawnFromDef(def, true)
  }

  addBreakable () {
    var def = { type: 'bPl', data: { x: this.pointer.x, y: this.pointer.y, width: 400, height: 300 } }
    this.scene.spawner.spawnFromDef(def, true)
  }

  addRepeating () {
    var def = { type: 'rPl', data: { x: this.pointer.x, y: this.pointer.y, width: 400, height: 100, speed: 2, speedX: 0 } }
    this.scene.spawner.spawnFromDef(def, true)
  }

  addObstacleGun () {
    var def = { type: 'rObs', data: { x: this.pointer.x, y: this.pointer.y, width: 100, height: 100, noHeight: true, speed: 2 } }
    this.scene.spawner.spawnFromDef(def, true)
  }

  addGuidePoint () {
    // var def = { type: 'guP', data: { x: this.pointer.x, y: this.pointer.y } }
    // this.scene.spawner.spawnFromDef(def)
    // var pos = this.addMenu.buttons[0].image
    this.scene.spawner.addGuidePoint(this.addMenu.buttons[0].image.x, this.addMenu.buttons[0].image.y)
  }

  addGuideStart () {
    this.scene.spawner.addGuideStart(this.addMenu.buttons[0].image.x, this.addMenu.buttons[0].image.y, 500, true)
  }

  deleteObject (obj) {
    this.scene.spawner.onDelete(obj)
    obj.delete()
  }

  duplicateObject (obj) {
    var def = obj.toDef()
    def.data.x += 100
    def.data.y += 100

    this.scene.spawner.spawnFromDef(def, true)
  }

  // addFinish () {
  //   var def = { t: 'f', d: { x: this.pointer.x, y: this.pointer.y, w: 400, h: 300 } }
  //   this.scene.spawner.spawnFromDef(def)
  // }

  // addStart () {
  //   var def = { t: 'p', d: { x: this.pointer.x, y: this.pointer.y } }
  //   this.scene.spawner.spawnFromDef(def)
  // }

  convertObjectsToDefs (objects) {
    var defs = []
    for (var i = 0; i < objects.length; i++) {
      if (objects[i].doSave) {
        defs.push(objects[i].toDef())
      }
    }
    defs.sort(function (a, b) { return a.x - b.x })
    return defs
  }

  save (toFile = false) {
    var defs = this.convertObjectsToDefs(this.scene.spawner.objects)
    if (toFile) {
      const a = document.createElement('a')
      a.href = URL.createObjectURL(new Blob([JSON.stringify(defs)], {
        type: 'text/plain'
      }))
      a.setAttribute('download', 'level.json')
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    }
    return JSON.stringify(defs)
  }

  load () {
    var input = document.createElement('input')
    input.type = 'file'
    input.onchange = e => {
      var file = e.target.files[0]
      var reader = new FileReader()
      reader.readAsText(file, 'UTF-8')
      reader.onload = readerEvent => {
        var content = readerEvent.target.result
        // this.scene.game.registry.set('lastLevel', content)
        this.scene.clearLevel()
        this.scene.startLevel(content, 0)
        this.scene.player.image.x = 0
        this.scene.player.image.y = 0
        // this.scene.restart()
        // this.scene.levelEditor.enable()
      }
    }
    input.click()
  }

  loadEmptyLevel () {
    this.scene.clearLevel()
    this.scene.startNewLevel()
    // this.scene.isCustomLevel = true
    // this.scene.game.registry.set('lastLevel', 'NEW')
    // this.scene.restart()// startNewLevel()
    // this.game.levelEditor.enable()
  }
}
